import "./MyOrder.css";
import { Steps } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect, useLayoutEffect, useState } from "react";
import { Pagination } from "antd";
import { language } from "../../language/Language";
import {
  useGetOrderByIdMutation,
  useGetOrdersByContactIdMutation,
} from "../../RTK/Slices/Slices/apiSliceMeat";

const MyOrder: React.FC = () => {
  const navigate = useNavigate();
  const userData = localStorage.getItem("user");
  const jsonUserData = userData ? JSON.parse(userData) : null;
  const [selectedOrderDetails, setSelectedOrderDetails] = useState<any>(null);
  const [expandedOrder, setExpandedOrder] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  // Get current language from Redux store
  // const currentLanguage = useSelector((state: any) => state.language.language);
  const isArabic = language === "ar";

  console.log(isArabic);

  useLayoutEffect(() => {
    if (!userData) {
      navigate("/login");
    }
  }, [userData, navigate]);

  const [getOrdersByContactId, { data: orders, isLoading: loadingOrders }] =
    useGetOrdersByContactIdMutation();
  const [getOrderById, { data: orderDetails, isLoading: loadingOrderDetails }] =
    useGetOrderByIdMutation();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // جلب الطلبات مع معاملات الـ pagination
    const contactId = jsonUserData?.contact_id;

    // إذا كان الـ API يدعم pagination parameters
    getOrdersByContactId({
      contactId,
      page: currentPage,
      per_page: pageSize,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getOrdersByContactId, currentPage, pageSize]);

  // دالة لجلب تفاصيل طلب معين
  const handleGetOrderDetails = async (orderId: number) => {
    if (expandedOrder === orderId) {
      setExpandedOrder(null);
      setSelectedOrderDetails(null);
    } else {
      setExpandedOrder(orderId);
      await getOrderById(orderId);
    }
  };

  // تحديث تفاصيل الطلب المحدد عند تغيير البيانات
  useEffect(() => {
    if (orderDetails && expandedOrder) {
      setSelectedOrderDetails(orderDetails);
    }
  }, [orderDetails, expandedOrder]);

  // دالة لتحديد حالة الطلب للـ Steps
  const getOrderStatus = (shippingStatus: string) => {
    switch (shippingStatus) {
      case "ordered":
        return 0;
      case "packed":
        return 1;
      case "shipped":
        return 2;
      case "delivered":
        return 3;
      case "cancelled":
        return 4; // حالة الإلغاء
      default:
        return 0;
    }
  };

  // دالة لتنسيق التاريخ
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(isArabic ? "ar-EG" : "en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // دالة لتغيير الصفحة
  const handlePageChange = (page: number, size?: number) => {
    setCurrentPage(page);
    if (size && size !== pageSize) {
      setPageSize(size);
      // إعادة تعيين الصفحة إلى 1 عند تغيير حجم الصفحة
      setCurrentPage(1);
    }
    // إغلاق أي طلب مفتوح عند تغيير الصفحة
    setExpandedOrder(null);
    setSelectedOrderDetails(null);
  };

  const formatCurrency = (amount: string) => {
    return parseFloat(amount).toFixed(2);
  };

  // Translation texts
  const texts = {
    myOrders: isArabic ? "طلباتك" : "My Orders",
    order: isArabic ? "طلب" : "Order",
    orders: isArabic ? "طلبات" : "Orders",
    loading: isArabic ? "جاري تحميل الطلبات..." : "Loading orders...",
    orderNumber: isArabic ? "طلب رقم" : "Order Number",
    orderDate: isArabic ? "تاريخ الطلب" : "Order Date",
    paymentStatus: isArabic ? "حالة الدفع" : "Payment Status",
    paid: isArabic ? "مدفوع" : "Paid",
    pending: isArabic ? "مستحق" : "Pending",
    address: isArabic ? "العنوان" : "Address",
    recipient: isArabic ? "المستلم" : "Recipient",
    shippingCharges: isArabic ? "رسوم الشحن" : "Shipping Charges",
    totalBeforeTax: isArabic ? "الإجمالي قبل الشحن " : "Total Before Shipping",
    loadingDetails: isArabic ? "جاري التحميل..." : "Loading...",
    hideProductDetails: isArabic
      ? "إخفاء تفاصيل المنتجات"
      : "Hide Product Details",
    showProductDetails: isArabic
      ? "عرض تفاصيل المنتجات"
      : "Show Product Details",
    requestedProducts: isArabic ? "المنتجات المطلوبة" : "Requested Products",
    quantity: isArabic ? "الكمية" : "Quantity",
    perUnit: isArabic ? "للوحدة" : "Per Unit",
    subtotal: isArabic ? "المجموع الفرعي" : "Subtotal",
    shipping: isArabic ? "رسوم الشحن" : "Shipping",
    tax: isArabic ? "الضريبة" : "Tax",
    discount: isArabic ? "الخصم" : "Discount",
    total: isArabic ? "الإجمالي" : "Total",
    currency: isArabic ? "جنيه" : "EGP ",
    noOrders: isArabic ? "لا توجد طلبات مكتملة" : "No completed orders",
    stepTitles: {
      ordered: isArabic ? "تم الطلب" : "Ordered",
      packed: isArabic ? " تم التأكيد " : "Confirmed",
      shipped: isArabic ? "تم الشحن" : "Shipped",
      delivered: isArabic ? "تم التوصيل" : "Delivered",
      cancelled: isArabic ? "ملغي" : "Cancelled",
    },
    pagination: {
      itemsPerPage: isArabic ? "/ صفحة" : "/ page",
      jumpTo: isArabic ? "الذهاب إلى" : "Go to",
      jumpToConfirm: isArabic ? "تأكيد" : "confirm",
      page: isArabic ? "صفحة" : "Page",
      prevPage: isArabic ? "الصفحة السابقة" : "Previous Page",
      nextPage: isArabic ? "الصفحة التالية" : "Next Page",
      prev5: isArabic ? "5 صفحات سابقة" : "Previous 5 Pages",
      next5: isArabic ? "5 صفحات تالية" : "Next 5 Pages",
      prev3: isArabic ? "3 صفحات سابقة" : "Previous 3 Pages",
      next3: isArabic ? "3 صفحات تالية" : "Next 3 Pages",
      showTotal: (total: number, range: [number, number]) =>
        isArabic
          ? `${range[0]}-${range[1]} من أصل ${total} ${texts.order}`
          : `${range[0]}-${range[1]} of ${total} ${texts.orders}`,
    },
  };

  if (loadingOrders) {
    return (
      <div className="orders min-h-screen flex justify-center items-center">
        <div className="text-lg">{texts.loading}</div>
      </div>
    );
  }

  // استخراج معلومات الترقيم من الاستجابة
  const ordersData = orders?.data || [];
  const metaInfo = orders?.meta || {};
  const totalOrders = metaInfo.total || 0;
  const currentPageFromAPI = metaInfo.current_page || 1;
  const perPageFromAPI = metaInfo.per_page || 50;
  const lastPage = metaInfo.last_page || 1;

  // حساب النطاق الحالي للعرض
  const startIndex = (currentPageFromAPI - 1) * perPageFromAPI + 1;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const endIndex = Math.min(startIndex + ordersData.length - 1, totalOrders);

  return (
    <div
      className="orders min-h-screen flex flex-col items-center py-8 px-4"
      style={{ direction: isArabic ? "rtl" : "ltr" }}
    >
      <h1 className="text-2xl font-bold mb-5">
        {texts.myOrders} {totalOrders > 0 && `(${totalOrders} ${texts.order})`}
      </h1>

      <div className="w-full max-w-4xl flex flex-col gap-5">
        {ordersData.length > 0 ? (
          ordersData.map((order: any) => (
            <div
              key={order.id}
              className="orders__order border rounded-lg shadow-md p-5 bg-white"
            >
              {/* معلومات الطلب الأساسية */}
              <div
                className={`flex justify-between items-center mb-4 pb-4 border-b ${
                  isArabic ? "text-right" : "text-left"
                }`}
              >
                <div>
                  <h3 className="text-lg font-semibold">
                    {texts.orderNumber}: {order.invoice_no}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {texts.orderDate}: {formatDate(order.transaction_date)}
                  </p>
                  <p className="text-xs text-gray-500">ID: {order.id}</p>
                </div>
                <div className={isArabic ? "text-right" : "text-left"}>
                  <p className="text-lg font-bold text-mainColor">
                    {formatCurrency(order.final_total)} {texts.currency}
                  </p>
                  <p className="text-sm text-gray-600">
                    {texts.paymentStatus}:
                    <span
                      className={`${
                        isArabic ? "mr-1" : "ml-1"
                      } px-2 py-1 rounded text-xs ${
                        order.payment_status === "paid"
                          ? "bg-green-100 text-mainColor"
                          : "bg-yellow-100 text-yellow-800"
                      }`}
                    >
                      {order.payment_status === "paid"
                        ? texts.paid
                        : texts.pending}
                    </span>
                  </p>
                </div>
              </div>

              {/* تفاصيل الشحن */}
              <div className="mb-4">
                <div className="flex justify-center my-5">
                  <Steps
                    className="w-full"
                    current={getOrderStatus(order.shipping_status)}
                    status={
                      order.shipping_status === "cancelled"
                        ? "error"
                        : "process"
                    }
                    items={[
                      { title: texts.stepTitles.ordered },
                      { title: texts.stepTitles.packed },
                      { title: texts.stepTitles.shipped },
                      { title: texts.stepTitles.delivered },
                      ...(order.shipping_status === "cancelled"
                        ? [{ title: texts.stepTitles.cancelled }]
                        : []),
                    ]}
                  />
                </div>
              </div>

              {/* معلومات الشحن والتوصيل */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <p className="text-sm">
                    <strong>{texts.address}:</strong> {order.shipping_details}
                  </p>
                  <p className="text-sm">
                    <strong>{texts.recipient}:</strong> {order.delivered_to}
                  </p>
                </div>
                <div>
                  <p className="text-sm">
                    <strong>{texts.shippingCharges}:</strong>{" "}
                    {formatCurrency(order.shipping_charges)} {texts.currency}
                  </p>
                  <p className="text-sm">
                    <strong>{texts.totalBeforeTax}:</strong>{" "}
                    {formatCurrency(order.total_before_tax)} {texts.currency}
                  </p>
                </div>
              </div>

              {/* زر عرض تفاصيل المنتجات */}
              <button
                onClick={() => handleGetOrderDetails(order.id)}
                className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-md transition-colors"
                disabled={loadingOrderDetails && expandedOrder === order.id}
              >
                {loadingOrderDetails && expandedOrder === order.id
                  ? texts.loadingDetails
                  : expandedOrder === order.id
                  ? texts.hideProductDetails
                  : texts.showProductDetails}
              </button>

              {/* تفاصيل المنتجات */}
              {expandedOrder === order.id && selectedOrderDetails?.data && (
                <div className="mt-4 border-t pt-4">
                  <h4 className="text-lg font-semibold mb-3">
                    {texts.requestedProducts}:
                  </h4>
                  <div className="space-y-3">
                    {selectedOrderDetails.data.map(
                      (item: any, index: number) => (
                        <div
                          key={`${item.id}-${index}`}
                          className={`flex justify-between items-center p-3 bg-gray-50 rounded ${
                            isArabic ? "text-right" : "text-left"
                          }`}
                        >
                          <div className="flex-1">
                            <h5
                              className={`font-medium ${
                                isArabic ? "text-right" : "text-left"
                              }`}
                            >
                              {item.product_name}
                            </h5>
                            <p className="text-sm text-gray-600">
                              {texts.quantity}:{" "}
                              {parseFloat(item.quantity).toFixed(0)}
                            </p>
                          </div>
                          <div
                            className={isArabic ? "text-right" : "text-left"}
                          >
                            <p className="font-semibold">
                              {formatCurrency(item.unit_price_inc_tax)}{" "}
                              {texts.currency}
                            </p>
                            <p className="text-sm text-gray-600">
                              {texts.perUnit}
                            </p>
                          </div>
                        </div>
                      )
                    )}
                  </div>

                  {/* ملخص التكلفة */}
                  <div className="mt-4 p-3 bg-blue-50 rounded">
                    <div className="flex justify-between text-sm mb-1">
                      <span>{texts.subtotal}:</span>
                      <span>
                        {formatCurrency(order.total_before_tax)}{" "}
                        {texts.currency}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm mb-1">
                      <span>{texts.shipping}:</span>
                      <span>
                        {formatCurrency(order.shipping_charges)}{" "}
                        {texts.currency}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm mb-1">
                      <span>{texts.tax}:</span>
                      <span>
                        {formatCurrency(order.tax_amount)} {texts.currency}
                      </span>
                    </div>
                    {order.discount_amount &&
                      parseFloat(order.discount_amount) > 0 && (
                        <div className="flex justify-between text-sm mb-1 text-red-600">
                          <span>{texts.discount}:</span>
                          <span>
                            -{formatCurrency(order.discount_amount)}{" "}
                            {texts.currency}
                          </span>
                        </div>
                      )}
                    <div className="flex justify-between font-bold border-t pt-2">
                      <span>{texts.total}:</span>
                      <span>
                        {formatCurrency(order.final_total)} {texts.currency}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="text-center py-10">
            <p className="text-lg text-gray-600">{texts.noOrders}</p>
          </div>
        )}

        {/* Pagination Controls */}
        {totalOrders > 0 && lastPage > 1 && (
          <div className="flex justify-center mt-8">
            <Pagination
              current={currentPageFromAPI}
              total={totalOrders}
              pageSize={perPageFromAPI}
              showSizeChanger={false}
              showQuickJumper={true}
              showTotal={(total, range) =>
                texts.pagination.showTotal(total, range)
              }
              onChange={(page) => handlePageChange(page)}
              locale={{
                items_per_page: texts.pagination.itemsPerPage,
                jump_to: texts.pagination.jumpTo,
                jump_to_confirm: texts.pagination.jumpToConfirm,
                page: texts.pagination.page,
                prev_page: texts.pagination.prevPage,
                next_page: texts.pagination.nextPage,
                prev_5: texts.pagination.prev5,
                next_5: texts.pagination.next5,
                prev_3: texts.pagination.prev3,
                next_3: texts.pagination.next3,
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MyOrder;
